import * as React from "react";
const SvgFiRrTachometerSlowest = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tachometer-slowest_svg__a)">
      <path
        fill="#062147"
        d="M20.445 21.516a3.014 3.014 0 0 1-4.073.128l-1.026-.887a1 1 0 0 1 1.308-1.514l1.027.888a1 1 0 0 0 1.357-.037 10 10 0 1 0-14.114-.038 1.016 1.016 0 0 0 1.395.076l1.027-.889a1 1 0 0 1 1.308 1.514l-1.027.888a3.036 3.036 0 0 1-4.12-.176A12.06 12.06 0 0 1 4 4.052C11.02-2.364 22.755 2 23.9 11.437a11.96 11.96 0 0 1-3.455 10.08M12 11a2 2 0 0 0-1.988 1.78l-4.867 2.136a1 1 0 1 0 .8 1.832l4.867-2.136A1.993 1.993 0 1 0 12 11"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tachometer-slowest_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTachometerSlowest;
